import { queryOptions } from '@tanstack/react-query'
import { leaderboardKeys } from './keys'
import { CACHE_TIMES } from './cache-config'
import { studentLeaderboardApi } from '@/lib/api/student-leaderboard'

/**
 * Quantos alunos a tela pede. O saneamento REAL é da api
 * (`limiteDoRanking`: NaN/0/negativo → 10, teto 100); aqui é só o padrão da
 * tela, para a rota e o prefetch usarem a MESMA chave de cache — chave
 * diferente do `queryOptions` do componente refaz a requisição no cliente e o
 * prefetch do loader vira desperdício.
 */
export const DEFAULT_LEADERBOARD_LIMIT = 10

export function leaderboardQueryOptions(params?: { limit?: number }) {
  const limit = params?.limit ?? DEFAULT_LEADERBOARD_LIMIT

  return queryOptions({
    queryKey: leaderboardKeys.list({ limit }),
    queryFn: async () => {
      const { data, error } = await studentLeaderboardApi().api.student.leaderboard.get({
        query: { limit },
      })
      if (error) throw error
      return data
    },
    staleTime: CACHE_TIMES.STALE_LIST,
  })
}
